export default {
  title: 'A sua avaliação ajuda muito ❤️',
  description: '{{name}} na {{store}} — basta tocar numa estrela',
  buttons: {
    not_now: 'Agora não',
    continue: 'Continuar',
  },
};
